<template>
    <div class="sc__analysis__tab__box tab-content">
        <div class=" sc__analysis__head__box">
            <div class="title__box rlms-flex rlms-justify-between">
                <div class="rlms-flex rlms-items-center rlms-gap-10">
                    <h3 class="title">Analysis</h3>
                    <div class="video__info__btn__item transcription-setting" style="padding: 0;">
                        <a href="https://www.youtube.com/watch?v=958mx_NZa0M" target="_blank" rel="noopener" class="popup-youtube rlms-flex rlms-items-center" @click="showVideoTutorial = true">
                            <span class="badge rlms-fw-600 rlms-flex rlms-items-center rlms-gap-5"><span class="material-symbols-outlined">help</span> Help</span>
                        </a>
                    </div>
                </div>

                <div class="print__data__btn">
                    <WorkpacketPdf :button-label="`Download`" :assessmentId="assessmentId"
                        :organizationId="organizationId" :learnerId="learnerId"
                        v-if="assessmentId && organizationId && learnerId" />
                </div>
            </div>
            <div class="head__label__box__wrapper">
                <div class="lable____head__title">
                    <label class="label__title">Directions</label>
                    <label class="label__title">Info Source</label>
                </div>
                <div class="divider__sepline"></div>
                <div class="head__info__box">
                    <div class="info__box">
                        <p>In Column A, each test item that scored 1 point is highlighted.</p>
                    </div>
                    <div class="info__box analysis_grp1item analysis_grpitem active" style="">
                        <p>Items shown in grey were removed while selecting the items of Group {{ group }}.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="sc__analysis__data__box">
            <div class="inner__group__block">
                <div class="analysis__data__box">
                    <div class="analysis__data__head">
                        <div class="column__head__title">
                            <h6 class="column__title">Column A</h6>
                            <div class="column__subtitle">
                                <span>Test Item</span>
                            </div>
                        </div>
                        <div class="column__head__title center">
                            <h6 class="column__title">Column B</h6>
                            <div class="column__subtitle">
                                <span>Syll</span>
                                <span>C</span>
                                <span>V</span>
                            </div>
                        </div>
                        <div class="column__head__title">
                            <h6 class="column__title rlms-text-end">Column C</h6>
                            <div class="column__subtitle rlms-text-end">
                                <span>SC Code</span>
                            </div>
                        </div>
                    </div>
                    <div class="divider__sepline"></div>
                    <div class="column__data__box__wrapper analysis_grp1item analysis_grpitem active" style="">
                        <div class="column__data__row" v-for="question in workpacket?.groupQuestions" :key="question.id"
                            :class="{ active__column__row: Number(question?.attempts?.[0].score) === 1 }">
                            <div class="column__item left__item">
                                <span>{{ question.question }}</span>
                                <p>{{ formatConsonants(question.consonant) }}</p>
                            </div>
                            <div class="column__item column__group center__item">
                                <span>{{ question.scv?.charAt(0) ?? '' }}</span>
                                <span>{{ question.scv?.charAt(1) ?? '' }}</span>
                                <span>{{ question.scv?.charAt(2) ?? '' }}</span>
                            </div>
                            <div class="column__item right__item">
                                <span v-html="formatSuperscript(question.sccode)"></span>
                            </div>
                        </div>
                        <div class="" v-if="!workpacket?.groupQuestions?.length">
                            <div class="assetssment__no__data__block datanotfound rlms-w-100"
                                style=" min-height: 439px; display: flex; flex-direction: column; align-items: center; justify-content: center; ">
                                <div class="assetssment__no__data__img rlms-mb-3">
                                    <img :src="notFoundImg" alt="No data" width="150" class="rlms-mx-auto">
                                </div>
                                <div class="assetssment__data__text__box rlms-mb-3 rlms-text-center">
                                    <h4 v-if="workpacket?.assessment?.skip_group1 == 1 && group == 1">You have skipped
                                        this section. Normal Score is 01 02 03</h4>
                                    <h4 v-else-if="workpacket?.assessment?.skip_group2 == 1 && group == 2">You have
                                        skipped this section. Normal Score is 01 02 03</h4>
                                    <h4 v-else>No test item seleced for group {{ group }}.</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="analysis__data__box">
                    <div class="analysis__data__head">
                        <div class="column__head__title">
                            <h6 class="column__title">Column A</h6>
                            <div class="column__subtitle">
                                <span>Test Item</span>
                            </div>
                        </div>
                        <div class="column__head__title center">
                            <h6 class="column__title">Column B</h6>
                            <div class="column__subtitle">
                                <span>Syll</span>
                                <span>C</span>
                                <span>V</span>
                            </div>
                        </div>
                        <div class="column__head__title">
                            <h6 class="column__title rlms-text-end">Column C</h6>
                            <div class="column__subtitle rlms-text-end">
                                <span>SC Code</span>
                            </div>
                        </div>
                    </div>
                    <div class="divider__sepline"></div>
                    <div class="column__data__box__wrapper analysis_grp1item analysis_grpitem active">
                        <div class="column__data__row deactive__column__row"
                            v-for="question in workpacket?.groupQuestionsRemoved" :key="question.id">
                            <div class="column__item left__item">
                                <span>{{ question.question }}</span>
                                <p>{{ formatConsonants(question.consonant) }}</p>
                            </div>
                            <div class="column__item column__group center__item">
                                <span>{{ question.scv?.charAt(0) ?? '' }}</span>
                                <span>{{ question.scv?.charAt(1) ?? '' }}</span>
                                <span>{{ question.scv?.charAt(2) ?? '' }}</span>
                            </div>
                            <div class="column__item right__item">
                                <span v-html="formatSuperscript(question.sccode)"></span>
                            </div>
                            <div class="deactive__notice__box__wrapper">
                                <h6 class="notice__title">Data</h6>
                                <div class="short__info__box">
                                    <p>Items shown in grey were removed while selecting the assessment test items.</p>
                                </div>
                            </div>
                        </div>
                        <div class="" v-if="!workpacket?.groupQuestions?.length">
                            <div class="assetssment__no__data__block datanotfound rlms-w-100"
                                style=" min-height: 439px; display: flex; flex-direction: column; align-items: center; justify-content: center; ">
                                <div class="assetssment__no__data__img rlms-mb-3">
                                    <img :src="notFoundImg" alt="No data" width="150" class="rlms-mx-auto">
                                </div>
                                <div class="assetssment__data__text__box rlms-mb-3 rlms-text-center">
                                    <h4 v-if="workpacket?.assessment?.skip_group1 == 1 && group == 1">You have skipped
                                        this section. Normal Score is 01 02 03</h4>
                                    <h4 v-else-if="workpacket?.assessment?.skip_group2 == 1 && group == 2">You have
                                        skipped this section. Normal Score is 01 02 03</h4>
                                    <h4 v-else>No test item seleced for group {{ group }}.</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { formatConsonants, formatSuperscript } from '@/utils/format-helpers';
import { onMounted, ref, toRefs, watch } from 'vue';
import WorkpacketPdf from './WorkpacketPdf.vue';
import notFoundImg from '@/assets/images/not-found-img.png';
import { handleError } from '@/utils/handleError';
import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

const props = defineProps({
    organizationId: Number,
    assessmentId: Number,
    learnerId: Number,
    group: Number,
});

const { group } = toRefs(props);

const workpacket = ref(null)

const loader = useLoaderStore();

const fetchAssessment = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/workpacket`, {
            params: {
                group: group.value
            }
        });
        workpacket.value = data.data
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

watch(group, () => {
    fetchAssessment();
});

onMounted(async () => {
    await fetchAssessment();

    $('.popup-youtube').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
});
</script>